import { render, staticRenderFns } from "./create-rule-action.vue?vue&type=template&id=0f40c1e6"
import script from "./create-rule-action.ts?vue&type=script&lang=js&external"
export * from "./create-rule-action.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports